"use client";

import { useEffect, useRef, useState } from "react";
import { ArrowLeft, ArrowRight, Quote } from "lucide-react";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const testimonials = [{
  quote: "Phoenix Enterprise TCP provided an impeccable experience. The vehicle was pristine, and the chauffeur was professional, punctual, and incredibly discreet. Truly the gold standard for luxury travel in Los Angeles.",
  name: "Robert D.",
  role: "BUSINESS EXECUTIVE / BEVERLY HILLS",
  project: "AIRPORT TRANSFER / 2024",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/client_robert.webp"
}, {
  quote: "I rely on Phoenix for all my VIP transportation needs. Their attention to detail and commitment to privacy makes every trip seamless. It is the only service I trust for my high-profile guests.",
  name: "Sarah M.",
  role: "EVENT PLANNER / HOLLYWOOD",
  project: "VIP TRANSPORT / 2024",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/client_sarah.webp"
}, {
  quote: "The level of service is unmatched. From the moment I booked, the communication was clear and the driver was waiting exactly where promised. A stress-free, upscale experience every time.",
  name: "Jonathan K.",
  role: "TECH FOUNDER / SANTA MONICA",
  project: "HOURLY BOOKING / 2024",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/client_jonathan.png"
}, {
  quote: "Reliability is key in Los Angeles traffic, and Phoenix Enterprise TCP delivers every single time. Their fleet is top-tier, and the drivers are true professionals who know the city perfectly.",
  name: "Elena V.",
  role: "PRIVATE CLIENT / MALIBU",
  project: "SPECIAL OCCASION / 2024",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/client_elena.png"
}, {
  quote: "Exceptional service. The SUV was spotless and the chauffeur was courteous and attentive. It made our anniversary evening feel truly special and completely worry-free.",
  name: "Marcus T.",
  role: "PRIVATE CLIENT / PASADENA",
  project: "EVENT BOOKING / 2024",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/client_marcus.png"
}, {
  quote: "I have used many car services in LA, but Phoenix stands out for their professionalism and vehicle quality. They are my go-to for all business travel and airport arrivals.",
  name: "Sofia L.",
  role: "CORPORATE TRAVELER / DOWNTOWN LA",
  project: "LAX TRANSFER / 2024",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/client_sofia.webp"
}];
export default function Testimonials() {
  const [activeIndex, setActiveIndex] = useState(0);
  const [isHovered, setIsHovered] = useState(false);
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);
  useEffect(() => {
    if (isHovered) {
      if (intervalRef.current) clearInterval(intervalRef.current);
      return;
    }
    intervalRef.current = setInterval(() => {
      setActiveIndex(prev => (prev + 1) % testimonials.length);
    }, 8000);
    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, [isHovered]);
  const handlePrev = () => {
    setActiveIndex(prev => (prev - 1 + testimonials.length) % testimonials.length);
  };
  const handleNext = () => {
    setActiveIndex(prev => (prev + 1) % testimonials.length);
  };
  const current = testimonials[activeIndex];
  const prevIndex = (activeIndex - 1 + testimonials.length) % testimonials.length;
  const nextIndex = (activeIndex + 1) % testimonials.length;
  const prev = testimonials[prevIndex];
  const next = testimonials[nextIndex];
  const counter = `${String(activeIndex + 1).padStart(2, "0")} / ${String(testimonials.length).padStart(2, "0")}`;
  return;
}